<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
import 'echarts-wordcloud';

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
      newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
      jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
      processData(cptDataForm,newData,jsFunFlag)
      loadChart(props.option.attribute);
      })
}

function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                    let groupData = {};
                    res.forEach(item => {
                      let group = item[dataKey[0].value];
                      let name = item[dataKey[1].value];
                      let value = item[dataKey[2].value]

                      if (!groupData[group]) {
                        groupData[group] = { group, data: [] };
                      }
                      groupData[group].data.push({ name, value });
                     });

                    // 将 groupData 转换为 newarr 数组形式
                    let newarr = Object.values(groupData).map(groupItem => ({
                      ...groupItem,
                   }));
                   console.log(newarr,'新数组')
                   cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
    }
    
function loadChart(attr){
  let series = []
  cptData.forEach((group,index) => {
    let data = []
    group.data.forEach((item,i) => {
      data.push([i, index+1, item.value])
    })
    series.push({
      type: 'line3D',
      name: group.group,
      
      lineStyle: attr.series.lineStyle,
      data: data
    })
    series.push({
      type: 'scatter3D',
      name: group.group,
      
      symbolSize: attr.series.symbolSize,
      label: attr.series.label,
      data: data
    })
  })

  chartOption = {
    color: attr.color,//配色方案
    title: attr.title,
    tooltip: {
      formatter: function(param) {
        return param.seriesName + ':' + param.data[2]
      }
    },
    xAxis3D: attr.xAxis,
    yAxis3D: {
      show: false,
      name: '',
      data: [],
    },
    zAxis3D: attr.yAxis,
    grid3D: {
      boxWidth: 200,
      boxDepth: attr.boxDepth,
      axisLine: {
        lineStyle: {
          color: '#ffffff',
          opacity: 1,
        },
      },
      axisPointer: {
        show: true,
      },
      splitLine: {
        show: false,
      },
      viewControl: {
        alpha: 0,
        beta: 0,
        animation: true,
      },
    },
    series: series,
  }
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>
<style scoped>

</style>